// Effect 3 — Tween / easing (the atom). Demonstrates the overshoot-and-settle motion the whole
// rig leans on: the utterance row punches in past its resting scale and eases back (easeOutBack).
// The reusable tween()/easeOutBack live in anim.ts; this effect is the visible proof they work.
import { feel } from "../feel";
import { tween, easeOutBack } from "../anim";
import { registerEffect } from "../registry";
import { intensity, timed } from "../../tuner/scale";

export function registerTween(): void {
  registerEffect(
    { name: "tween", label: "3 · Tween/settle" },
    "word:valid",
    ({ tiles }) => {
      const row = tiles[0]?.parentElement as HTMLElement | undefined;
      if (!row) return;
      const ease = easeOutBack(feel.tween.overshoot * intensity(feel.tween)); // intensity = overshoot
      void tween(timed(feel.tween.settleMs), ease, (v) => {
        // v overshoots past 1 then settles — map to a subtle scale on the whole row.
        row.style.transform = `scale(${0.9 + 0.1 * v})`;
      });
    },
  );
}
